const PREVIEWABLE_EXTENSIONS = new Set([
  'pdf',
  'txt',
  'log',
  'md',
  'markdown',
  'json',
  'csv',
  'doc',
  'docx',
  'xls',
  'xlsx',
  'ppt',
  'pptx',
])

/** Mirrors the formats the API can preview; the API remains the authority. */
export function isPreviewableFileName(fileName: string): boolean {
  const dot = fileName.lastIndexOf('.')

  return (
    dot >= 0 &&
    PREVIEWABLE_EXTENSIONS.has(fileName.slice(dot + 1).toLowerCase())
  )
}
